export default {
  ibssc: {
    development: "https://menueauswahl.apetito.de",
    staging: "https://menueauswahl.apetito.de",
    production: "https://menueauswahl.apetito.de",
  },
};
